import { Button, Box, styled } from "@mui/material";
import { APP_BACKGROUND_COLOR,APP_COLOR, APP_HOVER_COLOR, FONT_FAMILY } from "../../theme";

export const NFTContainer = styled(Box)(() => ({
  width: "100%",
  borderRadius: 10,
  boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.8)",
  padding: 15,
}));

export const ContainedButton = styled(Button)({
  marginTop: "15px",
  backgroundColor: APP_COLOR,
  textTransform: "none",
  borderColor: APP_COLOR,
  "&:hover": {
    borderColor: APP_COLOR,
    backgroundColor: APP_HOVER_COLOR,
  },
  fontFamily: FONT_FAMILY,
});

export const modalStyles = {
  contributeShareContainer: {
    display: "flex",
    flexDirection: "column",
  } as const,
  contributorsHeading: {
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    marginRight: "5px",
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: 1,
  } as const,
  contributorsPhotoContainer: {
    display: "flex",
    color: "black",
    backgroundColor: APP_BACKGROUND_COLOR,
    justifyContent: "flex-end",
  } as const,
  contributorNavLink: {
    marginRight: "5px",
    textDecoration: "none",
    fontFamily: FONT_FAMILY,
    color: APP_COLOR,
  } as const,
  contributorsPhotos: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    marginBottom: "5px",
  } as const,
  container: {
    paddingTop: 40,
    paddingBottom: 40,
    display: "flex",
    flexDirection: "column",
    marginTop: "60px",
  } as const,
  information: {
    display: "flex",
    alignItems: "flex-end",
    marginBottom: 5,
  } as const,
  descriptionHeader: {
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    marginTop: 5,
    marginBottom: 1,
  } as const,
  openSeaUrlContainer: {
    display: "flex",
    marginTop: 10,
    alignItems: "center",
    justifyContent: "flex-end",
  }as const,
};
